import { object, string, ref } from 'yup';
import { isIESite } from '../../helpers/pages';
import { validatePostCode } from '../../helpers/validations';
import {
  REQUIRED_FIELD,
  REGISTER_ENTER_VALID_POSTCODE,
  PASSWORD_SIX_CHARACTERS,
  REGISTER_MATCH_PASSWORD,
  ENTER_VALID_EMAIL,
} from '../text/text';

// form types
export const TYPE_PAYMENT = 'TYPE_PAYMENT';
export const TYPE_PAYMENT_UNDERLINED = 'TYPE_PAYMENT_UNDERLINED';
export const TYPE_UNDERLINED = 'TYPE_UNDERLINED';

export const editProfileFormConfig = [
  { id: 'profile_name', inputLabel: 'First Name', inputName: 'firstName' },
  { id: 'profile_surname', inputLabel: 'Surname', inputName: 'lastName' },
  { id: 'profile_email', inputLabel: 'Email', inputName: 'email' },
  {
    id: 'profile_addr1',
    inputLabel: 'Address Line 1',
    inputName: 'addressLine1',
  },
  {
    id: 'profile_addr2',
    inputLabel: 'Address Line 2',
    inputName: 'addressLine2',
  },
  { id: 'profile_tow_city', inputLabel: 'Town/City', inputName: 'town' },
  {
    id: 'profile_postcode',
    inputLabel: `${isIESite() ? 'eircode' : 'Postcode'}`,
    inputName: 'postcode',
  },
];

export const editFormSchemaValidation = (isPostcodeOnly) => {
  return object().shape({
    addressLine1: isPostcodeOnly ? string() : string().required(REQUIRED_FIELD),
    addressLine2: string(),
    email: string().required(REQUIRED_FIELD).email(ENTER_VALID_EMAIL),
    firstName: string().required(REQUIRED_FIELD),
    lastName: string().required(REQUIRED_FIELD),
    postcode: isIESite()
      ? string()
      : string()
          .required(REQUIRED_FIELD)
          .test('postcode', REGISTER_ENTER_VALID_POSTCODE, (value) =>
            validatePostCode(value),
          ),
    town: isPostcodeOnly ? string() : string().required(REQUIRED_FIELD),
  });
};

export const updatePasswordFormConfig = [
  {
    id: 'passwordOld',
    inputLabel: 'Current password',
    inputName: 'oldPassword',
  },
  { id: 'passwordNew', inputLabel: 'New password', inputName: 'newPassword' },
  {
    id: 'passwordConfirm',
    inputLabel: 'Confirm new password',
    inputName: 'confirmNewPassword',
  },
];

export const updatePasswordSchemaValidation = object().shape({
  confirmNewPassword: string()
    .required(REQUIRED_FIELD)
    .min(6, PASSWORD_SIX_CHARACTERS)
    .when('newPassword', {
      is: (value) => Boolean(value && value.length > 0),
      then: string().oneOf([ref('newPassword')], REGISTER_MATCH_PASSWORD),
    }),
  newPassword: string()
    .required(REQUIRED_FIELD)
    .min(6, PASSWORD_SIX_CHARACTERS),
  oldPassword: string()
    .required(REQUIRED_FIELD)
    .min(6, PASSWORD_SIX_CHARACTERS),
});
